import { adminRequest } from './adminApi'

export interface AdminUser {
  user_id: string
  username: string
  display_name: string
  trust_level: number
  is_admin: boolean
  is_active: boolean
  created_at: number
}

export interface ListAdminUsersParams {
  limit: number
  offset: number
  q?: string
}

export interface ListAdminUsersResponse {
  limit: number
  offset: number
  users: AdminUser[]
}

export interface PatchAdminUserBody {
  trust_level?: number
  is_admin?: boolean
  is_active?: boolean
}

export interface ResetAdminUserPasswordBody {
  new_password: string
}

export interface ResetAdminUserPasswordResponse {
  user_id: string
  deleted_sessions: number
}

export interface TopUpAdminCreditsBody {
  user_id?: string
  username?: string
  amount: number
  idempotency_key: string
  note?: string
}

export type TopUpAdminCreditsResponse = Record<string, unknown>

export function listAdminUsers(params: ListAdminUsersParams): Promise<ListAdminUsersResponse> {
  const query = new URLSearchParams()
  query.set('limit', String(params.limit))
  query.set('offset', String(params.offset))
  const q = params.q?.trim()
  if (q) query.set('q', q)
  return adminRequest<ListAdminUsersResponse>(`/v1/admin/users?${query.toString()}`)
}

export function patchAdminUser(userId: string, body: PatchAdminUserBody): Promise<AdminUser> {
  return adminRequest<AdminUser>(`/v1/admin/users/${encodeURIComponent(userId)}`, {
    method: 'PATCH',
    body,
  })
}

export function resetAdminUserPassword(
  userId: string,
  body: ResetAdminUserPasswordBody,
): Promise<ResetAdminUserPasswordResponse> {
  return adminRequest<ResetAdminUserPasswordResponse>(
    `/v1/admin/users/${encodeURIComponent(userId)}/reset-password`,
    {
      method: 'POST',
      body,
    },
  )
}

export function topUpAdminCredits(body: TopUpAdminCreditsBody): Promise<TopUpAdminCreditsResponse> {
  return adminRequest<TopUpAdminCreditsResponse>('/v1/admin/credits/topup', {
    method: 'POST',
    body,
  })
}
